<template>
  <div>
    <div class="card-container">
      <p class="font-semibold">
        Attachment
      </p>
      <div class="mt-5 flex flex-col">
        <div
          class="w-11/12 flex flex-row items-center"
          :class="[disabled ? 'cursor-not-allowed' : 'cursor-pointer']"
          @click="handleClick"
        >
          <div class="bg-clip-attachment">
            <img :src="require('../../assets/shipo-icon-attachment.svg')">
          </div>
          <span class="text-grey-001">Choose file</span>
          <input
            ref="file"
            type="file"
            class="hidden"
            @change="fileHandler"
          >
        </div>
        <div class="self-center w-full">
          <vs-progress
            indeterminate
            v-show="isUploading"
            color="secondary"
          />
        </div>
      </div>
      <div v-if="files.length">
        <div class="divider-dashed" />
        <div
          v-for="(item, index) of files"
          class="mb-5"
          :key="index"
        >
          <div class="bg-file-attachment">
            <img
              :src="getFileIconByType(getFileType(item))"
              class="w-24"
              :class="getFileBackground(getFileType(item))"
            >
            <div class="ml-5 flex flex-col">
              <span>{{ item.original_name || item.name }}</span>
              <span class="text-grey-001">{{ item.file_size || 0 }} {{ item.file_size_type || 'B' }}</span>
            </div>
            <img
              v-show="!disabled"
              :src="require('../../assets/shipo-sales-plan-icon-trash.svg')"
              class="ml-auto cursor-pointer"
              @click="removeFile(item, index)"
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /*
    * `value` should `Array of files`
    * ex : [File{}, File{}, File{}]
    * */
    value: {
      type: Array,
      default: () => []
    },
    isUploading: {
      type: Boolean,
      default: () => false
    },
    disabled: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      files: this.value
    }
  },
  watch: {
    value: {
      handler(val) {
        this.files = val
      }
    }
  },
  methods: {
    fileHandler(e) {
      this.$emit('upload', e.target.files[0])
    },
    getFileType(file) {
      return file.ext
    },
    getFileBackground(type) {
      switch (type) {
        case 'xlsx':
        case 'xls':
        case 'pdf':
          return
        default:
          return 'p-3 bg-white rounded-3xl'
      }
    },
    getFileIconByType(type) {
      switch (type) {
        case 'xlsx':
        case 'xls':
          return require('../../assets/shipo-sales-plan-icon-excel.svg')
        case 'pdf':
          return require('../../assets/shipo-sales-plan-icon-pdf.svg')
        default:
          return require('../../assets/shipo-icon-attachment.svg')
      }
    },
    removeFile(file, index) {
      this.$emit('delete', { file, index })
    },
    handleClick() {
      if (this.disabled) {
        return
      }

      this.$refs.file.click()
    }
  }
}
</script>

<style lang="scss" scoped>
.card-container {
  @apply p-5 flex flex-col rounded-lg bg-white;
}

.bg-clip-attachment {
  @apply p-3 mr-5 border border-primary border-dashed rounded-xl;

  background-color: #F1F1FD;
}

.bg-file-attachment {
  @apply p-5 flex flex-row items-center rounded-2xl;

  background-color: #F1F1FD;
}

.divider-dashed {
  @apply my-5 border border-b border-dashed border-grey-002;
}
</style>
